export const Footer = () => {
    return <div className="p-4 border-t-[1px] border-slate-300">
        <div className="container mx-auto">
            <div className="text-sm text-center text-gray-500">Copyright © 2026 The JuICE Team. All Rights Reserved.</div>
        </div>
    </div>
}